module.exports = __webpack_public_path__ + "img/pic_501.293d5ed4.png";